<script lang="ts">
	import { onMount } from 'svelte';

	export let style: string = 'light';
	export let image: string = undefined;
	export let title: string = 'Contact Us';

	const textColorClass = style == 'light' ? '' : 'white-color';
	const containerGridClasses = image
		? 'col-md-5 col-sm-7 col-md-offset-7 col-sm-offset-5'
		: 'col-md-8 col-md-offset-2';
	const titleAlignmentClass = image ? '' : 'text-center';

	onMount(() => {
		const script = document.createElement('script');
		
		script.onload = () => {
			if (Tally) {
				Tally.loadEmbeds();
			}
		};

		script.src = 'https://tally.so/widgets/embed.js';
		document.head.appendChild(script);
	});
</script>

<section id="schedule-estimate" class="{style}-bg form-style-one">
	{#if image}
		<div class="col-md-6 col-sm-4 bg-flex bg-flex-left">
			<div class="bg-flex-holder bg-flex-cover" style="background-image: url({image});" />
		</div>
	{/if}
	<div class="container">
		<div class="{containerGridClasses} {textColorClass}">
			<h1 class="mb-0 font-700 text-uppercase mt-0 {titleAlignmentClass}">{title}</h1>
			<div class="mt-50 full-height">
				<iframe
					title="Contact"
					data-tally-src="https://tally.so/embed/m62o1Y?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
					width="100%"
					height="100%"
					frameborder="0"
					marginheight="0"
					marginwidth="0"
				/>
			</div>
			<style lang="scss">
				.full-height {
					height: 100%;
				}
				.form-control {
					height: 65px;
				}

				.form-group.condensed {
					margin-bottom: 10px;
				}
			</style>
		</div>
	</div>
</section>
